import { Alert, AlertProps, ListItem, UnorderedList } from 'evergreen-ui';
import React, { FC } from 'react';

type ValidationMessageType = 'warnings' | 'errors';

export interface ValidationMessagesComponentProps {
  messages: string[];
  type: ValidationMessageType;
  children?: never;
}

const intentMap: Record<ValidationMessageType, AlertProps> = {
  warnings: { intent: 'warning', title: 'Take a closer look' },
  errors: { intent: 'danger', title: 'Please correct this record' },
};

export const ValidationMessagesComponent: FC<ValidationMessagesComponentProps> = ({ type, messages }) => {
  if (!messages?.length) return null;

  return (
    <Alert {...intentMap[type]} flex="100%" paddingBottom="calc(15px - 0.5rem)">
      <UnorderedList>
        {messages.map((message, index) => (
          <ListItem size={300} key={index}>
            {message}
          </ListItem>
        ))}
      </UnorderedList>
    </Alert>
  );
};
